import Image from 'next/image';
import styles from './nft-info.module.css';
import HeartIcon from './heart.svg';

import CardImage1 from '../../public/nft/info/card-1.jpg';
import CardImage3 from '../../public/nft/info/card-3.jpg';
import CardImage2 from '../../public/nft/info/card-2.jpg';
import CardImage4 from '../../public/nft/info/card-4.jpg';
import NFTDivided from './nft-divided';
import { Container } from '../../components';

export default function NFTInfo() {
  return (
    <section className={styles.section}>
      <Container variant="container_medium">
        <NFTDivided className={styles.dividedStart} />
        <div className={styles.block}>
          <h3 className={styles.blockTitle}>The Potential of NFT</h3>
          <p className={styles.blockText}>
            If we parse the abbreviation, we get that NFT is Non-fungible
            tokens. It is something that cannot be faked, replaced or stolen.
            You may have heard on the news about users selling their NFTs for a
            million dollars when they could either make their own or buy for a
            few dollars earlier. And it is true. But not always NFT on the
            markets is digital art, you can often find unique items for video
            games, collectible tokens and domain names. Many companies are
            already creating their collections and are looking for platforms to
            sell them. Buyers know that after analyzing the NFT collection, it
            can be assumed that in time the price will increase significantly.
            Everyone is interested in this process: buyers, sellers, and a
            platform that serves as an intermediary. If you want to be in the
            last group, join the world of NFTs, we will help you to develop your
            own NFT marketplace!
          </p>
        </div>
        <NFTDivided className={styles.divided} />
        <div className={styles.block}>
          <h3 className={styles.blockTitle}>What are NFTs?</h3>
          <p className={styles.blockText}>
            Any digital file, even a photo of your animal, can become a
            non-fungible token. After that, the NFT begins to be tracked using
            blockchain technology. Cryptocurrencies like Bitcoin and Ethereum
            work on the same principle. All transaction information is visible
            and open to everyone. This method allows buyers and sellers to keep
            a clear record of file ownership.
          </p>

          <p className={styles.blockText}>
            You might think that this makes no sense, because everything can be
            faked and a screenshot taken. But, unfortunately or fortunately,
            this will not work. We all know the painting &quot;Mona Lisa&quot;
            by Leonard da Vinci. You can even put it as a wallpaper, print it,
            but this picture will not be of value. Everyone knows that the
            original is in the museum and it&apos;s cost is more than 860
            million dollars ! This is a good example that a copy will never
            replace the original.
          </p>

          <ul className={styles.list}>
            <li className={styles.item}>
              <div className={styles.nft}>
                <div className={styles.nftTop}>
                  <div className={styles.nftName}>NFT name</div>
                  <div className={styles.nftLike}>
                    <HeartIcon />
                    212
                  </div>
                </div>
                <div className={styles.nftCard}>
                  <div className={styles.nftCardImg}>
                    <Image
                      alt="NFT info"
                      src={CardImage1}
                      placeholder="blur"
                      width={236}
                      height={225}
                    />
                  </div>
                  <div className={styles.nftCardFooter}>
                    <span className={styles.nftCardBitLabel}>Current Bid</span>
                    <span className={styles.nftCardBitValue}>37,52 ETH</span>
                  </div>
                </div>
              </div>
            </li>

            <li className={styles.item}>
              <div className={styles.nft}>
                <div className={styles.nftTop}>
                  <div className={styles.nftName}>NFT name</div>
                  <div className={styles.nftLike}>
                    <HeartIcon />
                    212
                  </div>
                </div>
                <div className={styles.nftCard}>
                  <div className={styles.nftCardImg}>
                    <Image
                      alt="NFT info"
                      src={CardImage2}
                      placeholder="blur"
                      width={236}
                      height={225}
                    />
                  </div>
                  <div className={styles.nftCardFooter}>
                    <span className={styles.nftCardBitLabel}>Current Bid</span>
                    <span className={styles.nftCardBitValue}>37,52 ETH</span>
                  </div>
                </div>
              </div>
            </li>

            <li className={styles.item}>
              <div className={styles.nft}>
                <div className={styles.nftTop}>
                  <div className={styles.nftName}>NFT name</div>
                  <div className={styles.nftLike}>
                    <HeartIcon />
                    212
                  </div>
                </div>
                <div className={styles.nftCard}>
                  <div className={styles.nftCardImg}>
                    <Image
                      alt="NFT info"
                      src={CardImage3}
                      placeholder="blur"
                      width={236}
                      height={225}
                    />
                  </div>
                  <div className={styles.nftCardFooter}>
                    <span className={styles.nftCardBitLabel}>Current Bid</span>
                    <span className={styles.nftCardBitValue}>37,52 ETH</span>
                  </div>
                </div>
              </div>
            </li>

            <li className={styles.item}>
              <div className={styles.nft}>
                <div className={styles.nftTop}>
                  <div className={styles.nftName}>NFT name</div>
                  <div className={styles.nftLike}>
                    <HeartIcon />
                    212
                  </div>
                </div>
                <div className={styles.nftCard}>
                  <div className={styles.nftCardImg}>
                    <Image
                      alt="NFT info"
                      src={CardImage4}
                      placeholder="blur"
                      width={236}
                      height={225}
                    />
                  </div>
                  <div className={styles.nftCardFooter}>
                    <span className={styles.nftCardBitLabel}>Current Bid</span>
                    <span className={styles.nftCardBitValue}>37,52 ETH</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <NFTDivided className={styles.divided} />
        <div className={styles.block}>
          <h3 className={styles.blockTitle}>
            An Introduction to NFT Marketplace Development
          </h3>
          <p className={styles.blockText}>
            There are different categories of NFTs. Some marketplaces include
            many categories at once, while others choose their own niche and
            develop specifically in it. One marketplace deals only with high
            art, another deal with game skins, and the third one includes all
            categories.
          </p>
          <div className={styles.listMark}>
            <h4 className={styles.listMarkTitle}>A list of popular NFTs:</h4>
            <ul className={styles.listMarklist}>
              <li className={styles.listMarklistItem}>Digital Artwork</li>
              <li className={styles.listMarklistItem}>Music</li>
              <li className={styles.listMarklistItem}>Clips</li>
              <li className={styles.listMarklistItem}>GIFs</li>
              <li className={styles.listMarklistItem}>Photos</li>
              <li className={styles.listMarklistItem}>Tweets</li>
              <li className={styles.listMarklistItem}>Games</li>
              <li className={styles.listMarklistItem}>Domains</li>
              <li className={styles.listMarklistItem}>Tokens</li>
              <li className={styles.listMarklistItem}>Licenses</li>
            </ul>
          </div>
        </div>
        <NFTDivided />
      </Container>
    </section>
  );
}
